import React, { useEffect, useMemo } from "react";
import useStore from "../../../../useStore";
import Loader from "../../../Elements/Loader/Loader";
import "./almacen.css";

const Almacen = () => {
    const { fetchTodosLosProductos, productosTotales, loading, error } = useStore();

    useEffect(() => {
        fetchTodosLosProductos();
    }, [fetchTodosLosProductos]);

    const porAlmacen = useMemo(() => {
        const mapa = {};
        productosTotales.forEach((prod) =>
            prod.almacenes.forEach(({ nombre, total }) => {
                mapa[nombre] = (mapa[nombre] || 0) + total;
            })
        );

        const nombresDeseados = [
            "CENTRAL",
            "ANEXO 2",
            "ANX-1-DISPONIBLE",
            "ESPECIALES",
            "ESPECIALES-ANX2"
        ];

        return Object.entries(mapa).filter(([nombre]) =>
            nombresDeseados.includes(nombre)
        );
    }, [productosTotales]);

    return (
        <div className="almacen-container container-mh">
            <h2 className="almacen-title">Totales por Almacén</h2>

            {loading && <Loader className="loader" />}

            {!loading && error && (
                <div className="alert alert-danger">{error}</div>
            )}

            {!loading && !error && (
                <div className="almacen-row">
                    {porAlmacen.map(([nombre, suma]) => (
                        <div key={nombre} className="almacen-col">
                            <div className="almacen-card">
                                <div className="almacen-card-body">
                                    <h5 className="almacen-card-title">{nombre}</h5>
                                    <p className="almacen-card-total">
                                        {suma.toLocaleString("es-MX", {
                                            minimumFractionDigits: 3,
                                        })}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Almacen;
